import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArrowDownwardSvg } from "./IconArrowDownwardSvg.mjs";
const IconArrowDownward = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArrowDownwardSvg, ...iconProps });
};
export {
  IconArrowDownward
};
